import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Colors, transparentize } from '../../Constants/Colors';
import { Spacing } from '../../Constants/Spacing';
import { Typography } from '../../Constants/Typography';
import useInheritedTheme from '../../Hooks//UseInheritedTheme';
import Portal from '../../Components/Utility/Portal';
import { createAnimation } from '../../Constants/Animation';
import { Size } from '../../Constants/System';
export default function LoadingSpinner(props) {
    const theme = useInheritedTheme();
    const propsWithDefaults = {
        ...props,
        textColor: props.textColor || theme.schemes.primary.text,
        backgroundColour: props.backgroundColour || theme.palette.primary,
        opacity: props.opacity !== undefined ? props.opacity : 0.4,
        size: props.size || Size.medium,
    };
    const content = (_jsxs(SpinnerContainer, { "$overlay": propsWithDefaults.overlay, "$fullPageOverlay": propsWithDefaults.fullPageOverlay, "$backgroundColour": propsWithDefaults.backgroundColour, "$minHeight": propsWithDefaults.minHeight, "$opacity": propsWithDefaults.opacity, "$textColor": propsWithDefaults.textColor, children: [_jsx(PlanetSpinner, { size: propsWithDefaults.size }), props.text ? _jsx("p", { children: props.text }) : null] }));
    if (props.fullPageOverlay) {
        return _jsx(Portal, { children: content });
    }
    return content;
}
const SpinnerContainer = styled.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	${(props) => (props.$minHeight ? `min-height: ${props.$minHeight};` : ``)}

	${(props) => props.$overlay || props.$fullPageOverlay
    ? css `
					position: absolute;
					top: 0;
					left: 0;
					height: 100%;
					width: 100%;
					background-color: ${transparentize(props.$backgroundColour, 1 - props.$opacity)};
					z-index: 700;
				`
    : ``}
        
        > p {
		margin-top: ${Spacing.lg};
		font-size: ${Typography.md};
		color: ${(props) => props.$textColor};
	}
`;
export function PlanetSpinner(props) {
    const size = props.size ? props.size : Size.medium;
    return (_jsxs(PlanetSpinnerWrapper, { className: props.className, "$size": size, children: [_jsx(BigPlanet, { color: Colors.green }), _jsx(Planet, { color: Colors.pink }), _jsx(Planet, { color: Colors.purple }), _jsx(Planet, { color: Colors.orange })] }));
}
const SizeMap = {
    [Size.small]: '50px',
    [Size.medium]: '100px',
    [Size.large]: '150px',
};
const BigPlanet = styled.div `
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 1;
	width: 60%;
	height: 60%;
	border-radius: 100%;
	transform: translate(-50%, -50%);
	${createAnimation({ name: 'ball-atom-shrink', duration: '4.5s' })};
	background: ${(props) => props.color};

	@keyframes ball-atom-shrink {
		50% {
			transform: translate(-50%, -50%) scale(0.8, 0.8);
		}
	}
`;
const PlanetSpinnerWrapper = styled.div `
	position: relative;
	box-sizing: border-box;

	display: block;
	font-size: 0;
	color: #fff;

	--size: ${(props) => SizeMap[props.$size]};
	width: var(--size);
	height: var(--size);
	margin: calc(var(--size) / 3);

	> div:not(:nth-child(1)) {
		position: absolute;
		left: 0;
		z-index: 0;
		width: 100%;
		height: 100%;
		background: none;
		animation: ball-atom-zindex 1.5s 0s infinite steps(2, end);
	}

	> div:not(:nth-child(1)):before {
		position: absolute;
		top: 0;
		left: 0;
		width: calc(var(--size) / 4);
		height: calc(var(--size) / 4);
		margin-top: calc(var(--size) / -8);
		margin-left: calc(var(--size) / -8);
		content: '';
		border-radius: 50%;
		transform: translate(0%, 0%);
		animation: ball-atom-size 1.5s 0s infinite ease;
	}

	> div:nth-child(2) {
		animation-delay: 0.75s;

		&:before {
			animation-delay:
				0s,
				-1.125s;
		}
	}

	> div:nth-child(3) {
		transform: rotate(120deg);
		animation-delay: -0.25s;

		&:before {
			animation-delay:
				-1s,
				-0.75s;
		}
	}

	> div:nth-child(4) {
		transform: rotate(240deg);
		animation-delay: 0.25s;

		&:before {
			animation-delay:
				-0.5s,
				-0.125s;
		}
	}

	@keyframes ball-atom-position {
		50% {
			transform: translate(100%, 100%);
		}
	}
	@keyframes ball-atom-size {
		50% {
			transform: scale(0.5, 0.5) translate(700%, 700%);
		}
	}
	@keyframes ball-atom-zindex {
		50% {
			z-index: 10;
		}
	}
`;
const Planet = styled.div `
	position: relative;
	box-sizing: border-box;

	display: inline-block;
	float: none;
	background-color: currentColor;
	border: 0 solid currentColor;

	&:before {
		background: ${(props) => props.color};
	}
`;
export { PlanetSpinnerWrapper };
//# sourceMappingURL=LoadingSpinner.js.map